// extracted by mini-css-extract-plugin
export var footer = "_py-0";
export var inherit = "_py-1";
export var input = "_py-2";
export var modalContent = "_py-3";
export var quillEditor = "_py-4";
export var subtitle = "_py-5";